import React, { useState, useEffect } from "react";
import {
  fetchAllTeachers,
  deleteTeacher,
  updateTeacherImage,
  fetchImag,
} from "../../../ApiController/teacherApi";
import { FiCamera } from "react-icons/fi";
import DefaultProfileImage from "../../../../Images/default-profile.webp";
import "./AdminPage.css";
import "./TeacherList.css"
import "bootstrap/dist/css/bootstrap.min.css";

const TeacherList = ({setDataChanged, dataChanged}) => {
  const [teachers, setTeachers] = useState([]);
  const [teacherImages, setTeacherImages] = useState({});
  

  useEffect(() => {
    const fetchTeacherData = async () => {
      try {
        let fetchedData;
        let teacherImg;
        if (dataChanged || !sessionStorage.getItem("teacherData")) {
          const response = await fetchAllTeachers();
          if (Array.isArray(response.teachers)) {
            fetchedData = response.teachers;
            sessionStorage.setItem("teacherData", JSON.stringify(fetchedData));

            teacherImg = fetchedData.reduce((acc, teacher) => {
              acc[teacher.id] = teacher.imgdata;
              return acc;
            }, {});
            sessionStorage.setItem("teachersImgs", JSON.stringify(teacherImg));
            setDataChanged(false); 
          } else {
            console.error("Svaret är inte en array:", response);
            return;
          }
        } else {
          fetchedData = JSON.parse(sessionStorage.getItem("teacherData"));
          teacherImg = JSON.parse(sessionStorage.getItem("teachersImgs"));
        }
  
        setTeachers(fetchedData);
        setTeacherImages(teacherImg);
      } catch (error) {
        console.error("Fel vid hämtning av lärare:", error);
      }
    };
  
    fetchTeacherData();
  }, [dataChanged, setDataChanged]);
  
  const handleDelete = async (id) => {
    const isConfirmed = window.confirm(
      `Är du säker på att du vill ta bort denna anställd med ID: ${id}?`
    );

    if (isConfirmed) {
      try {
        await deleteTeacher(id);
        alert(`Anställd med ID "${id}" har tagits bort`);
        setTeachers((prevTeachers) =>
          prevTeachers.filter((teacher) => teacher.id !== id)
        );

        const teacherData = JSON.parse(sessionStorage.getItem("teacherData"));
        const updatedTeacherData = teacherData.filter(
          (teacher) => teacher.id !== id
        );
        sessionStorage.setItem("teacherData", JSON.stringify(updatedTeacherData));

      } catch (error) {
        console.error("Det gick inte att ta bort anställd:", error);
        alert(
          error.response?.data?.error ||
          "Ett okänt fel inträffade vid borttagning av anställd."
        );
      }
    }
  };

  const handleImageChange = async (e, id) => {
    if (e.target.files && e.target.files[0]) {
      try {
        await updateTeacherImage(id, e.target.files[0]);
        alert("Bilden uppdaterades!");
        const newImage = await fetchImag(id);
        console.log();
        setTeacherImages((prevImages) => {
          const updatedImages = { ...prevImages, [id]: newImage.imgdata };
          sessionStorage.setItem("teachersImgs", JSON.stringify(updatedImages));
          return updatedImages;
        });
      } catch (error) {
        console.error("Error:", error);
        alert(
          error.response?.data?.error || "Det gick inte att uppdatera bilden."
        );
      }
    }
  };


  const handleImageError = (e) => {
    e.target.src = DefaultProfileImage;
  };

  return (
    <div className="container">
      <div className="d-flex flex-row flex-wrap justify-content-center align-items-center teacher-list-items">
        {teachers.map((teacher) => (
          <div key={teacher.id} className="card mb-1 me-1 custom-card-flexible">
            <div className="card-body">
              <form>
                <div className="image-container text-center">
                  <img
                    src={teacherImages[teacher.id] ? teacherImages[teacher.id] : DefaultProfileImage}
                    alt="Profile"
                    className="img-thumbnail mb-2 teacher-img"
                    onError={handleImageError}
                  />

                  <label
                    htmlFor={`image-upload-${teacher.id}`}
                    className="d-block label-flex"
                  >
                    <FiCamera size={20} className="camera-icon mt-1" />
                  </label>
                  <input
                    type="file"
                    id={`image-upload-${teacher.id}`}
                    hidden
                    onChange={(e) => handleImageChange(e, teacher.id)}
                    accept="image/*"
                  />
                </div>
                <div className="mb-2">
                  {["id", "förnamn", "efternamn"].map((field) => (
                    <div key={field}>
                      <label htmlFor={`${field}-${teacher.id}`} className="form-label">
                        {field === "id"
                          ? "ID"
                          : field.charAt(0).toUpperCase() + field.slice(1)}:
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name={field}
                        id={`${field}-${teacher.id}`} // Add id attribute for label association
                        value={
                          field === "id"
                            ? teacher.id
                            : field === "förnamn"
                              ? teacher.firstName
                              : teacher.lastName
                        }
                        readOnly
                        autoComplete={field === "id" ? "off" : "on"} // Add autocomplete attribute
                      />
                    </div>
                  ))}
                </div>
                <div className="mt-auto">
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(teacher.id)}
                  >
                    Radera
                  </button>
                </div>
              </form>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default TeacherList;